import styled from 'styled-components';
import { devices } from '../../../../styles/viewports';
import { Colors } from '../../../../types';
import { Grid } from '../../../atoms';

export const PanelGrid = styled(Grid)<{ color: string | undefined }>`
  gap: 0 var(--grid-column-gap);

  ${({ color }) => `
    background-color: ${color ? `var(--base-color-${color})` : 'var(--base-color-core)'};
    color: ${color === Colors.White ? 'var(--base-color-black)' : 'var(--base-color-white)'};
  `}

  @media ${devices.mobileAndTablet} {
    grid-template-rows: 48px max-content max-content;
  }
`;

export const LeftPanel = styled.div<{ hasImage: boolean }>`
  grid-area: ${({ hasImage }) => (hasImage ? '1 / 1 / 3 / 7' : '1 / 1 / 3 / 12')};
  box-sizing: border-box;
  height: 100%;
  display: grid;
  grid-auto-rows: 90% 1fr;
  gap: 0px 36px;
  align-items: center;

  @media ${devices.mobileAndTablet} {
    grid-area: ${({ hasImage }) => (hasImage ? '3 / 1 / 4 / 15' : '1 / 1 / 3 / 15')};
  }
`;

export const RightPanel = styled.div`
  grid-area: 1 / 7 / 3 / 17;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: var(--base-color-black);

  @media ${devices.mobileAndTablet} {
    grid-area: 2 / 1 / 3 / 15;
  }
`;

export const InfoWrapper = styled.div`
  margin: 36px;
  max-height: 33vw;
  overflow: hidden;

  :first-child * {
    margin-block-start: 0;
  }

  @media ${devices.mobileAndTablet} {
    margin: 36px 20px;
    max-height: unset;
  }
`;

export const ScrollDownWrapper = styled.div`
  padding: 0 0 25px 36px;

  @keyframes UpDown {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(8px);
    }
  }

  a {
    font-size: var(--font-size-overline-1);
    font-weight: var(--font-weight-overline-1);
    letter-spacing: var(--letter-spacing-overline-1);
    border: none;
    padding: 0;

    :hover {
      border: none;

      > span {
        animation: UpDown 1500ms linear infinite;
      }
    }
  }

  @media ${devices.mobileAndTablet} {
    display: none;
  }
`;
